<template>
    <div class="templates">
        <button class="button action spaced" @click="selectingTemplate = true">Select a Template</button>
        <button class="button action spaced" :disabled="!canEdit || !hasTemplateChanged || !selectedTemplateId" @click="savingTemplate = true">
            Update Selected Template
        </button>
        <h4 class="full-width">Selected Template: {{ selectedTemplateId }}</h4>
        <!-- <select v-model="selectedTemplateId">
            <option :value="null">Select Template</option>
            <option v-for="(template, templateId) in templateMap" :key="templateId" :value="templateId">
                {{ template.name }}
            </option>
        </select> -->
        <!-- <button class="button action spaced" :disabled="!canEdit || !selectedTemplateId" @click="$emit('applyTemplate', templateMap[selectedTemplateId].settings)">
            Apply Selected Template
        </button> -->
        <!-- <button class="button action spaced" :disabled="!canEdit || !hasTemplateChanged || !selectedTemplateId" @click="savingTemplate = true">
            Update Selected Template
        </button>
        <button class="button action spaced" :disabled="!canEdit" @click="savingTemplateAsNew = true">
            Save As A New Template
        </button> -->

        <div class="modal" v-if="savingTemplate || savingTemplateAsNew">
            <div class="inner">
                <h2>Save Template<template v-if="savingTemplateAsNew"> As New</template></h2>
                <div class="content">
                    <template v-if="!savingTemplateAsNew">
                        <label-required label="Template Name" />
                        <input type="text" v-model="selectedTemplate.name">
                    </template>
                    <template v-else>
                        <label-required label="New Template Name" />
                        <input type="text" v-model="newTemplateName">
                    </template>

                    <h3>Template</h3>
                    <selected-template-properties v-if="localCurrentTemplateData" :templateData="localCurrentTemplateData" @update:templateData="localCurrentTemplateData = $event" />
                </div>
                <div class="controls">
                    <div class="button cancel spaced" @click="savingTemplate = savingTemplateAsNew = false">Cancel</div>
                    <div class="button action spaced" @click="saveTemplate(savingTemplateAsNew)" :disabled="(savingTemplateAsNew && !newTemplateName) || !selectedTemplate.name">Save</div>
                </div>
            </div>
        </div>

        <div class="modal" v-if="selectingTemplate">
            <div class="inner">
                <h2>Select a GunBroker Template</h2>
                <div class="content">
                    <select v-model="selectedTemplateId">
                        <option :value="null">Select Template</option>
                        <option v-for="(template, templateId) in templateMap" :key="templateId" :value="templateId">
                            {{ template.name }}
                        </option>
                    </select>

                    <h3>This Template Info Will Be Applied:</h3>
                    <selected-template-properties v-if="localCurrentTemplateData" :templateData="localCurrentTemplateData" @update:templateData="localCurrentTemplateData = $event" />
                </div>
                <div class="controls">
                    <div class="button cancel spaced" @click="selectingTemplate = false">Cancel</div>
                    <div class="button action spaced" @click="$emit('applyTemplate', templateMap[selectedTemplateId].settings)" :disabled="!selectedTemplate.name">Apply This Template</div>
                </div>
            </div>
        </div>
        <button class="button action spaced" :disabled="!canEdit" @click="savingTemplateAsNew = true">
            Save As A New Template
        </button>
    </div>
</template>

<script>
import LabelRequired from '@/components/LabelRequired.vue';
import SelectedTemplateProperties from './SelectedTemplateProperties.vue';

export default {
    name: "Templates",
    components: {
        'label-required': LabelRequired,
        'selected-template-properties': SelectedTemplateProperties,
    },
    props: {
        templateGroupCode: {
            type: String,
            required: true
        },
        canEdit: {
            type: Boolean,
            required: true,
            default: false
        },
        currentTemplateData: {
            type: Object,
            required: false,
            default: null
        }
    },
    data() {
        return {
            templates: [],
            selectedTemplateId: null,
            savingTemplate: false,
            savingTemplateAsNew: false,
            newTemplateName: '',
            localCurrentTemplateData: null,
            selectingTemplate: false
        }
    },
    watch: {
        currentTemplateData: {
            handler(newVal) {
                this.localCurrentTemplateData = newVal ? JSON.parse(JSON.stringify(newVal)) : null;
            },
            immediate: true,
            deep: true
        }
    },
    computed: {
        selectedTemplate: {
            get() {
                return this.templateMap[this.selectedTemplateId] || { name: '', settings: {} };
            },
            set(value) {
                if (this.selectedTemplateId && this.templateMap[this.selectedTemplateId]) {
                    this.templateMap[this.selectedTemplateId].name = value.name;
                }
            }
        },
        templateMap() {
            const map = {};
            this.templates.forEach(template => {
                map[template.product_listing_template_id] = template;
                map[template.product_listing_template_id].name = template.settings.name;
            });            
            return map;
        },
        hasTemplateChanged() {
            if (!this.localCurrentTemplateData || !this.selectedTemplateId) {
                return false;
            }
            const selectedTemplate = this.templateMap[this.selectedTemplateId];
            if (!selectedTemplate) {
                return false;
            }
            return JSON.stringify(this.localCurrentTemplateData) !== JSON.stringify(selectedTemplate.data);
        }
    },
    mounted() {
        this.loadTemplates();
    },
    methods: {
        async loadTemplates() {
            await this.apiCall({ destination: 'get_list_product_listing_templates', data: { group_code: this.templateGroupCode }}).then(response => {
                this.templates = response.templates || [];
            }).catch(error => {
                console.error("Error loading templates:", error);
            });
        },
        saveTemplate(asNew = false) {
            if ((asNew && !this.newTemplateName) || (!asNew && !this.selectedTemplate.name) ) {
                return;
            }
            if (!this.canEdit || (!asNew && (!this.selectedTemplateId || !this.hasTemplateChanged)) ) {
                return;
            }

            const templateSettings = Object.fromEntries(
                Object.entries(this.localCurrentTemplateData).filter(([key, value]) => value.selected)
            );

            // Update the existing template with current data
            this.apiCall({ destination: 'save_product_listing_template', data: {
                product_listing_template_id: (asNew) ? null : this.selectedTemplateId,
                name: (asNew) ? this.newTemplateName : this.selectedTemplate.name,
                settings: templateSettings,
                group_code: this.templateGroupCode
            }}).then(async (response) => {
                await this.loadTemplates();
                this.selectedTemplateId = response.product_listing_template_id;
                this.savingTemplate = false;
                this.savingTemplateAsNew = false;
                this.newTemplateName = '';
            }).catch(error => {
                console.error("Error saving template:", error);
            });
        },
    }
}
</script>

<style lang="scss" scoped>
button:hover {
    filter: brightness(108%);
}

.modal {
    .inner {
        max-height: 50em;
        max-width: 60em;
        .content {
            max-height: 25em;
        }
    }
}
</style>